import type { SupportedLanguage } from '../../i18n'

/**
 * A language's flag, drawn here: flag emoji show as two letters on Windows.
 * English uses the Union Jack, Spanish the plain red-yellow-red bands; Russian shows none.
 */
export function LanguageFlag({ language, width = 36 }: { language: SupportedLanguage; width?: number }) {
  const height = Math.round((width * 2) / 3)
  const frame = { width, height, flex: 'none' as const, borderRadius: 4, display: 'block', boxShadow: '0 0 0 1px color-mix(in srgb, var(--om-ink) 14%, transparent)' }
  if (language === 'uk') {
    return (
      <svg viewBox="0 0 3 2" style={frame} aria-hidden="true">
        <rect width="3" height="1" fill="#0057B7" />
        <rect y="1" width="3" height="1" fill="#FFD700" />
      </svg>
    )
  }
  if (language === 'es') {
    return (
      <svg viewBox="0 0 4 4" preserveAspectRatio="none" style={frame} aria-hidden="true">
        <rect width="4" height="4" fill="#AA151B" />
        <rect y="1" width="4" height="2" fill="#F1BF00" />
      </svg>
    )
  }
  // Russian has no flag.
  if (language === 'ru') return null
  return (
    <svg viewBox="0 0 60 40" style={frame} aria-hidden="true">
      <rect width="60" height="40" fill="#012169" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#FFFFFF" strokeWidth="8" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="3" />
      <path d="M30,0 V40 M0,20 H60" stroke="#FFFFFF" strokeWidth="12" />
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="7" />
    </svg>
  )
}
